import type { AdminStore } from 'services/api/admin';

/**
 * store 转换成platform-region key的map
 */
export const groupBy = (arr: AdminStore[] = []): Record<string, AdminStore[]> => {
  return arr.reduce((res, item) => {
    const { externalType: platform, region } = item;
    const key = `${platform}-${region}`;
    res[key] = res[key] || [];
    res[key].push(item);
    return res;
  }, {} as Record<string, AdminStore[]>);
};

/**
 * 将General.StoreScope[] 转换成 ids
 */
export const convertStoreScopesToIds = (
  storeScopes: General.StoreScope[],
  source: Record<string, AdminStore[]>,
): number[] => {
  return (storeScopes || []).reduce<number[]>((res, item) => {
    const { platform, regionStoreScopes } = item;
    for (let i = 0; i < regionStoreScopes.length; i++) {
      const { region, storeIds, storeCount } = regionStoreScopes[i];
      if (region === 'all') {
        res = res.concat(
          Object.entries(source || {})?.reduce((acc2, cur2) => {
            const [key, value] = cur2;
            if (key.startsWith(platform)) {
              acc2 = acc2.concat(value?.map((e) => e.id));
              return acc2;
            }
            return acc2;
          }, [] as number[]),
        );
        break;
      } else {
        if (storeIds?.length === 0 && storeCount > 0) {
          res = res.concat(source[`${platform}-${region}`]?.map((e) => e.id));
        } else {
          res = res.concat(storeIds!);
        }
      }
    }
    return res;
  }, []);
};

/**
 * 将General.StoreScope[] 转换成 stores
 */
export const convertStoreScopesToStores = (
  storeScopes: General.StoreScope[],
  source: Record<string, AdminStore[]>,
): AdminStore[] => {
  return (storeScopes || []).reduce<AdminStore[]>((res, item) => {
    const { platform, regionStoreScopes } = item;
    for (let i = 0; i < regionStoreScopes.length; i++) {
      const { region, storeIds, storeCount } = regionStoreScopes[i];
      if (region === 'all') {
        res = res.concat(
          Object.entries(source || {})?.reduce((acc2, cur2) => {
            const [key, value] = cur2;
            if (key.startsWith(platform)) {
              acc2 = acc2.concat(value);
              return acc2;
            }
            return acc2;
          }, [] as AdminStore[]),
        );
        break;
      } else {
        if (storeIds?.length === 0 && storeCount > 0) {
          res = res.concat(source[`${platform}-${region}`]);
        } else {
          res = res.concat(
            source[`${platform}-${region}`]?.filter((e) => storeIds?.includes(e.id)),
          );
        }
      }
    }
    return res;
  }, []);
};
